import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { openDialog } from '../DialogModal/DialogModal';
var openModalUploadFile = function (props) {
    var calculateMbs = function (size) {
        if (size && size > 0) {
            return (size / 1024 / 1024).toFixed(2);
        }
        else {
            return 0;
        }
    };
    var fileNames = function (fileList) {
        var _a, _b;
        var names = [];
        if (fileList) {
            for (var index = 0; index < fileList.length; index++) {
                names.push(((_a = fileList.item(index)) === null || _a === void 0 ? void 0 : _a.name) + " (" + calculateMbs((_b = fileList.item(index)) === null || _b === void 0 ? void 0 : _b.size) + "mB)");
            }
        }
        return names;
    };
    openDialog({
        initialValue: {},
        title: props.dialogTitle || 'Upload File',
        body: function (formikProps) {
            var _a;
            return (React.createElement(Fragment, null,
                React.createElement("div", { className: "form-group col" },
                    React.createElement("div", { className: "custom-file" },
                        React.createElement("input", { required: true, id: "file", name: "file", type: "file", accept: (_a = props.accept) === null || _a === void 0 ? void 0 : _a.join(), onChange: function (event) {
                                if (event.currentTarget.files) {
                                    formikProps.setFieldValue('files', event.currentTarget.files);
                                }
                            }, className: "custom-file-input" }),
                        React.createElement("label", { className: "custom-file-label" }, fileNames(formikProps.values.files).join(', ') || 'Choose file(s)')))));
        }
    }).then(function (dialogResult) {
        if (dialogResult.result) {
            props.onConfirm(dialogResult.value);
        }
        else {
            props.onCancel();
        }
    });
};
export var FileUploadButton = function (props) {
    return (React.createElement(Button, { color: props.buttonColor, onClick: function () { return openModalUploadFile(props); } }, props.buttonContent || 'Select File(s)'));
};
//# sourceMappingURL=FileUploadButton.js.map